import { ComponentType } from "react"

export const BACKGROUND_COLORS = ["light", "dark", "tan"] as const
export type BackgroundColor = (typeof BACKGROUND_COLORS)[number]

export const COLORS = [
  "blue",
  "orange",
  "gold",
  "magenta",
  "gray",
  "original",
  "none",
] as const

export type Color = (typeof COLORS)[number]

export type IconSize = "small" | "medium"

export const ICON_SIZE: Record<IconSize, number> = {
  small: 32,
  medium: 56,
}

export type IconProps = {
  size?: IconSize
  color: Color
  bgToContrastWith?: BackgroundColor
  highlightAlways?: boolean
}

export type IconComponent = ComponentType<IconProps>
